import Component from "@base/js/component";

export default class TabPanels extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".tab-panels";

  // Defines children that needs to be queried as part of this component
  static children = {
    tabList: ".tab-panels__list",
    tabs: [".tab-panels__tab"],
    accordions: [".tab-panels__accordion"],
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    tabList: {
      keydown: this.onTabListKeydown,
    },
    tabs: {
      click: this.onTabClick,
    },
    accordions: {
      click: this.onAccordionClick,
    },
  };

  handleTabClick(targetTab) {
    if (!targetTab) {
      return;
    }

    const component = targetTab.closest(".tab-panels");

    // Remove all current selected tabs
    component
      .querySelectorAll('[role="tab"][aria-selected="true"]')
      .forEach((t) => {
        t.setAttribute("aria-selected", false);
      });

    // Set this tab as selected
    targetTab.setAttribute("aria-selected", true);

    // Hide all tab panels
    component
      .querySelectorAll('[role="tabpanel"]')
      .forEach((p) => p.classList.add("minimized"));

    // Prep target tab ID.
    const targetTabId = `#${targetTab.getAttribute("aria-controls")}`;

    // Show the selected panel
    component.querySelector(targetTabId).classList.remove("minimized");
  }

  onTabClick(e) {
    const targetTab = e.target;

    // Execute tab click.
    this.handleTabClick(targetTab);
  }

  onTabListKeydown(e) {
    const tabs = e.currentTarget.querySelectorAll('[role="tab"]');
    this.tabFocus = this.tabFocus || 0;

    if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
      tabs[this.tabFocus].setAttribute("tabindex", -1);

      // Move right
      if (e.key === "ArrowRight") {
        this.tabFocus += 1;
        // If we're at the end, go to the start
        if (this.tabFocus >= tabs.length) {
          this.tabFocus = 0;
        }
        // Move left
      } else if (e.key === "ArrowLeft") {
        this.tabFocus -= 1;
        // If we're at the start, move to the end
        if (this.tabFocus < 0) {
          this.tabFocus = tabs.length - 1;
        }
      }

      tabs[this.tabFocus].setAttribute("tabindex", 0);
      tabs[this.tabFocus].focus();
    }
  }

  onAccordionClick(e) {
    const button = e.currentTarget;
    const component = button.closest(".tab-panels");
    const targetTab = component.querySelector(`#${button.dataset.control}`);

    targetTab?.click();

    setTimeout(() => {
      button.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
TabPanels.init();
